import { ReceivingDisposition } from "@redotech/crdb-enums/fulfillment/receiving-disposition";
import * as z from "zod";
import {
  diffReturnsCenterValues,
  readReturnsCenterSettingPath,
  type ReturnsCenterValues,
} from "./returns-center-setting";

export const RECEIVING_DISPOSITION_PATH =
  "redoManagedReturns.receivingDisposition";

export const receivingDispositionSchema = z.enum(ReceivingDisposition);

export const RECEIVING_DISPOSITION_LABELS: Record<
  ReceivingDisposition,
  string
> = {
  [ReceivingDisposition.Consolidation]: "Consolidation",
  [ReceivingDisposition.Liquidation]: "Liquidation",
};

export function isReceivingDispositionPath(path: string): boolean {
  return path === RECEIVING_DISPOSITION_PATH;
}

export function parseReceivingDispositionValue(
  value: unknown,
): ReceivingDisposition | null {
  return value == null ? null : receivingDispositionSchema.parse(value);
}

export function diffReceivingDisposition(
  stored: ReceivingDisposition | null,
  next: ReceivingDisposition | null | undefined,
): {
  path: string;
  prev: ReceivingDisposition | null;
  next: ReceivingDisposition | null;
}[] {
  if (next === undefined || stored === next) {
    return [];
  }
  return [{ path: RECEIVING_DISPOSITION_PATH, prev: stored, next }];
}

export const RETURNS_CENTER_RECEIVING_DISPOSITION_PATH =
  "redoManagedReturns.returnsCenterReceivingDisposition";

/** A center's override; null uses the account-wide disposition. */
export const returnsCenterReceivingDispositionsSchema = z.record(
  z.string(),
  receivingDispositionSchema.nullable(),
);

export function readReturnsCenterReceivingDispositionPath(
  path: string,
): bigint | null {
  return readReturnsCenterSettingPath(
    RETURNS_CENTER_RECEIVING_DISPOSITION_PATH,
    path,
  );
}

export function isReturnsCenterReceivingDispositionPath(path: string): boolean {
  return readReturnsCenterReceivingDispositionPath(path) !== null;
}

export function diffReturnsCenterReceivingDispositions(
  stored: ReturnsCenterValues<ReceivingDisposition>,
  next: ReturnsCenterValues<ReceivingDisposition> | null | undefined,
): {
  path: string;
  prev: ReceivingDisposition | null;
  next: ReceivingDisposition | null;
}[] {
  return diffReturnsCenterValues(
    RETURNS_CENTER_RECEIVING_DISPOSITION_PATH,
    stored,
    next,
  );
}
